import { render } from "./GroupsFilter.vue?vue&type=template&id=6d971bfb&scoped=true"
import script from "./GroupsFilter.vue?vue&type=script&lang=js"
export * from "./GroupsFilter.vue?vue&type=script&lang=js"

import "./GroupsFilter.vue?vue&type=style&index=0&id=6d971bfb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d971bfb"]])

export default __exports__